/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Builder_StartInputs */

const en_cp_builder_start = /** @type {(inputs: Cp_Builder_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start from customers and the problem they pay for; an MVP in 3 sprints.`)
};

const id_cp_builder_start = /** @type {(inputs: Cp_Builder_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai dari pelanggan dan masalah yang mereka bayar; MVP dalam 3 sprint.`)
};

/**
* | output |
* | --- |
* | "Start from customers and the problem they pay for; an MVP in 3 sprints." |
*
* @param {Cp_Builder_StartInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_builder_start = /** @type {((inputs?: Cp_Builder_StartInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Builder_StartInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_builder_start(inputs)
	return en_cp_builder_start(inputs)
});